import { useState } from 'react';

export const useShoppingCartState = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isFilterSheetOpen, setFilterSheetOpen] = useState(false);

  return {
    isDrawerOpen,
    setDrawerOpen,
    isFilterSheetOpen,
    setFilterSheetOpen,
  };
};
